import { Service, inject } from '@angular/core';

import { ApiService } from './api.service';

import { SnackBarService } from './snackbar.service';
import { Transfer } from '../models/medic-actiuni.model';
import { Router } from '@angular/router';

import { DocCertProfCurent } from '../models/medic-doc.model';
import { AlertStore } from '../state/alert.store';
import { executa } from './executa';

@Service()
export class AlertsService {
  private readonly alertStore = inject(AlertStore);
  private apiService = inject(ApiService);
  private snackBar = inject(SnackBarService);
  private router = inject(Router);

  getAlert(endpoint: string) {
    return executa(this.apiService.getTransfer(endpoint), response => {
        switch (endpoint) {
          case 'transfer':
            this.alertStore.setTransfer(response as Transfer[]);
            break;

          case 'cpc':
            this.alertStore.setCpc(response as DocCertProfCurent[]);
            break;

          default:
            break;
        }
        // this.router.navigateByUrl('/');
    }, this.snackBar);
  }

  getCpcList(endpoint: string, full: string | number | boolean) {
    return executa(this.apiService.getCpc(endpoint, full), response => {
      this.alertStore.setCpc(response as DocCertProfCurent[]);
    }, this.snackBar);
  }
}
